var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Splitpanes',{staticClass:"default-theme",attrs:{"watch-slots":"","horizontal":_vm.horizontal}},[_vm._t(_vm.reverse ? 'last' : 'first'),_vm._t(_vm.reverse ? 'first' : 'last')],2)}
var staticRenderFns = []

export { render, staticRenderFns }